export default function contentLoadMore() {
	document.addEventListener('DOMContentLoaded', () => {
		//@ts-ignore
		const $ = jQuery;
		let page = 2;
		// @ts-ignore
		const loadMorePosts = window.loadMorePosts || {};

		const moreButton = $('#archive-view-more');

		function hideMoreButton() {
			$('#archive-pagination').hide();
		}

		if (moreButton.length) {
			moreButton.on('click', function () {

				const ajaxData = {
					action: 'load_more_posts',
					postType: loadMorePosts.postType,
					taxonomy: loadMorePosts.taxonomy,
					termId: loadMorePosts.termId,
					search: loadMorePosts.search,
					page: page,
					nonce: loadMorePosts.ajaxNonce,
				};
				$.ajax({
					url: loadMorePosts.ajaxUrl,
					type: 'POST',
					data: ajaxData,
				})// @ts-ignore
				.done(function (response) {
					$('#archive-container').append(response.html);
					page++;
					if ($('#archive-container > .post-list__item').length >= response.total_posts) {
						hideMoreButton();
					} else if (!response.show_button) {
						hideMoreButton();
					}
				})// @ts-ignore
				.fail(function (error) {
					console.error({error});
				});
			});
		}
	});
}
